export default __webpack_public_path__ + "static/media/clinical-app-3.b9793b6e.jpg";